import {
    UserCapabilitiesState,
    UserCapabilitiesResponse,
    FetchState
} from "@/shared/types";
import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: UserCapabilitiesState = {
    fetchState: FetchState.Uninitialized,
    capabilities: null
};

export const useUserCapabilitiesStore = defineStore("userCapabilities", {
    state: (): UserCapabilitiesState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
        cardManagementScreenVisible: state => {
            if (state.fetchState !== FetchState.Loaded) return false;

            return state.capabilities.cardManagementScreenVisible;
        }
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setUserCapabilities (userCapabilities: UserCapabilitiesResponse) {
            this.capabilities = userCapabilities;
            this.fetchState = FetchState.Loaded;
        },
        getUserCapabilities (): Promise<any> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            this.setFetchState(FetchState.Loading);
            return CardService.getUserCapabilities()
                .then(response => {
                    this.setUserCapabilities(response.data);
                }).catch(err => {
                    this.fetchState = FetchState.Uninitialized;
                    return storeHelper.handleError({ error: err, rethrow: true});
                });
        }
    }
});